import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Context as VendorContext } from '../../../providers/VendorContextProvider';
import VendorAdminListView from './VendorAdminListView';

const VendorAdminViews = ({ ecomVendor, loading }) => {
  const {} = useContext(VendorContext);

  return (
    <Routes>
      <Route
        element={
          <VendorAdminListView ecomVendor={ecomVendor} loading={loading} />
        }
        path="/"
      />
      <Route element={<Navigate replace to="/merchant/admins" />} path="*" />
    </Routes>
  );
};

VendorAdminViews.propTypes = {
  ecomVendor: PropTypes.object,
  loading: PropTypes.bool
};

export default VendorAdminViews;
